/**
 * 订阅相关API
 */

import type { ApiResponse } from './authApi';

export interface Subscription {
  id: string;
  user_id: string;
  tool_id: string;
  subscribed_at: string;
  enabled: boolean;
  usage_count: number;
  last_used_at?: string;
  // 关联的工具和服务器信息（从后端 join 查询返回）
  tool?: {
    id: string;
    name: string;
    display_name: string;
    description?: string;
    category?: string;
    is_published: boolean;
  };
  server?: {
    name: string;
    status: string;
  };
}

class SubscriptionsAPI {
  private baseURL = '/api/v2/my';

  /**
   * 获取我的订阅列表
   */
  async getMySubscriptions(token: string): Promise<ApiResponse<Subscription[]>> {
    const response = await fetch(`${this.baseURL}/subscriptions`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('获取订阅列表失败');
    }

    return response.json();
  }

  /**
   * 订阅工具
   */
  async subscribe(toolId: string, token: string): Promise<ApiResponse> {
    const response = await fetch(`${this.baseURL}/subscriptions/${toolId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || '订阅失败');
    }

    return response.json();
  }

  /**
   * 取消订阅
   */
  async unsubscribe(toolId: string, token: string): Promise<ApiResponse> {
    const response = await fetch(`${this.baseURL}/subscriptions/${toolId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || '取消订阅失败');
    }

    return response.json();
  }

  /**
   * 启用/禁用订阅
   */
  async toggleSubscription(subscriptionId: string, enabled: boolean, token: string): Promise<ApiResponse> {
    const response = await fetch(`${this.baseURL}/subscriptions/${subscriptionId}/enabled`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ enabled }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || '切换订阅状态失败');
    }

    return response.json();
  }

  /**
   * 批量订阅服务器的所有工具
   */
  async batchSubscribeByServer(serverName: string, token: string): Promise<ApiResponse> {
    const response = await fetch(`${this.baseURL}/subscriptions/batch/server/${encodeURIComponent(serverName)}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || '批量订阅失败');
    }

    return response.json();
  }
}

export const subscriptionsAPI = new SubscriptionsAPI();

